import StandardSection from './models/StandardSection'
import { loadSection } from '@/api/super'

let sectionModel = new StandardSection

export default {

  namespaced: true,

  state: {
    section: sectionModel
  },

  mutations: {
    ...sectionModel.mutations()
  },

  actions: {
    loadSection: ({ commit }, standardId) => new Promise((resolve, reject) => loadSection(standardId, ({ data }) => {
      commit('setSection', data)
      resolve()
    }, reject)),
  },

  getters: {
    section: state => state.section
  }

}